import { createFileRoute } from "@tanstack/react-router";

import { ClosingBand } from "@/features/portal/components/closing-band";
import { PortalHead, PortalPage } from "@/features/portal/components/portal-chrome";
import { ForWhomGoals, ForWhomHero } from "@/features/portal/modules/for-whom-page/for-whom-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/who-its-for/")({
  head: () => ({ meta: pageMeta({ title: m.portal_nav_for_whom(), description: m.seo_for_whom_description() }) }),
  loader: () => ({ crumb: m.portal_nav_for_whom() }),
  component: ForWhomPage,
});

/** Who the app is for: the three kinds of specialist to book, then the goals people come with. */
function ForWhomPage() {
  return (
    <PortalPage
      head={
        <PortalHead>
          <ForWhomHero />
        </PortalHead>
      }
    >
      <ForWhomGoals />
      <ClosingBand />
    </PortalPage>
  );
}
